import React, { useState } from "react";

//UI Material
import {
  Alert,
  Avatar,
  Card,
  Chip,
  Grid,
  LinearProgress,
  Stack,
} from "@mui/material";

//Helpers
import {
  typographyForSubtitles,
  typographyForText,
} from "../../Helpers/typography";
import { fetchWithTokenJSONPost } from "../../Helpers/network";
import { checkProductStatus } from "../../Helpers/orderFunctions";

//Local components
import ContainedButton from "../basics/ContainedButton";

//Material Icons
import { CheckCircle, Hardware } from "@mui/icons-material";

export default function ProducedItemStatus({
  product,
  interactions,
  getInteractions,
  getProductData,
}) {
  // ==========> Component States <==========
  //State for loading the start_product interaction
  const [isLoading, setIsLoading] = useState(false);

  //Function to create interactions
  const createInteraction = async (action, value) => {
    setIsLoading(true);
    try {
      const requestResponse = await fetchWithTokenJSONPost(
        "/interactions/create-product-interaction",
        {
          productId: product.productId,
          action,
          value,
        }
      );
      const jsonResponse = await requestResponse.json();
      if (jsonResponse.status === "ok") {
        getInteractions();
      }
      if (action === "PRODUCT_STARTED" || action === "PRODUCT_FINISHED") {
        getProductData();
      }
    } catch (error) {
      console.log(error);
    }
    setTimeout(() => {
      setIsLoading(false);
    }, 1400);
  };

  const buttonRender = () => {
    if (product.status === "PENDING") {
      return (
        <ContainedButton
          text="INICIAR PRODUCCIÓN"
          endIcon={<Hardware />}
          onClick={() => {
            createInteraction("PRODUCT_STARTED");
          }}
        />
      );
    } else {
      if (product.status === "FINISHED") {
        return null;
      }
      return (
        <Stack spacing={1} justifyContent="center" alignItems="center">
          <Alert severity="info">
            Antes de finalizar el producto asegúrese de haber asignado los
            identificadores S/N y ComMod en caso de necesitarlo.
          </Alert>
          <ContainedButton
            text="FINALIZAR PRODUCCIÓN"
            color="success"
            endIcon={<CheckCircle />}
            onClick={() => {
              createInteraction("PRODUCT_FINISHED");
            }}
          />
        </Stack>
      );
    }
  };

  return (
    <Card
      raised
      sx={{
        borderLeft: `8px solid ${checkProductStatus(product.status).color}`,
      }}
    >
      <Grid
        container
        sx={{ padding: "15px" }}
        spacing={1}
        justifyContent="center"
        alignItems="center"
        textAlign="center"
      >
        <Grid item xs={12}>
          {typographyForSubtitles("Producción", "secondary")}
        </Grid>
        <Grid item xs={12}>
          <Stack justifyContent="center" alignItems="center" spacing={1}>
            {typographyForText(
              `El producto ${product.aditionalData.productName} con identificador ${product.productId} se encuentra`,
              "secondary"
            )}
            <Chip
              label={checkProductStatus(product.status).status}
              sx={{
                backgroundColor: checkProductStatus(product.status).color,
                color: "white",
              }}
              avatar={
                <Avatar
                  sx={{ bgcolor: checkProductStatus(product.status).color }}
                >
                  {checkProductStatus(product.status).icon}
                </Avatar>
              }
            />
          </Stack>
        </Grid>
        <Grid item xs={12} sx={{marginTop: "10px"}}>
          {isLoading ? <LinearProgress /> : buttonRender()}
        </Grid>
      </Grid>
    </Card>
  );
}
